import {
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    SelectChangeEvent, Stack,
    TextField,
    Typography
} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router";
import Grid from '@mui/material/Grid2';
import {lightBlue, lightGreen} from "@mui/material/colors";
import {useTranslation} from "react-i18next";

export default function HomeSearchView() {
    const navigate = useNavigate();
    const [localUserAccount, setLocalUserAccount] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [accountNumberRegion, setAccountNumberAccountNumberRegion] = useState("JP");

    const [phoneRegion, setPhoneRegion] = useState("KR");

    const [accountNumberLookupEnabled, setAccountNumberLookupEnabled] = useState(false);
    const [phoneNumberLookupEnabled, setPhoneNumberLookupEnabled] = useState(false);
    const {t, i18n} = useTranslation();

    function handleAccountNumberLookupClicked() {
        navigate(`/lookupcustomeraccount/?region=${accountNumberRegion}&localUserAccount=${localUserAccount}`);
    }

    function handlePhoneNumberLookupClicked() {
        navigate(`/lookupcustomerphone/?region=${phoneRegion}&phone=${phoneNumber}`);
    }

    const handleAccountNumberRegionChange = (event: SelectChangeEvent) => {
        if (!event.target.value) {
            return;
        }
        setAccountNumberAccountNumberRegion(event.target.value as string);
    };

    const handlePhoneRegionChange = (event: SelectChangeEvent) => {
        setPhoneRegion(event.target.value as string);
    }

    useEffect(() => {
        setAccountNumberLookupEnabled(accountNumberRegion !== null && localUserAccount !== null && localUserAccount !== "");
    }, [accountNumberRegion, localUserAccount]);

    useEffect(() => {
        setPhoneNumberLookupEnabled(phoneRegion !== null && phoneNumber !== null && phoneNumber !== "");
    }, [phoneRegion, phoneNumber]);



    return (
            <Stack direction="row"  spacing={2}
                   sx={{
                       justifyContent: "center",
                       alignItems: "center",
                       p: 2
                   }}>
                 <Paper elevation={8} sx={{p: 0, bgcolor: lightGreen[50] }}>
                    <Grid container spacing={2}>
                        <Grid size={12} sx={{bgcolor: lightGreen[100], p: 1}}>
                            <Typography variant='h6'>{t('views.home.lookupByAccountPanel.title')}</Typography>
                        </Grid>
                        <Grid size={4} sx={{pl: 1}}>
                            <FormControl fullWidth>
                                <InputLabel id="region-select-label">{t('domain.common.region')}</InputLabel>
                                <Select
                                    id="region-select"
                                    labelId="region-select-label"
                                    label="{t('domain.common.region')}"
                                    value={accountNumberRegion}
                                    onChange={handleAccountNumberRegionChange}>
                                        <MenuItem value={"JP"}>Japan</MenuItem>
                                        <MenuItem value={"KR"}>Korea</MenuItem>
                                        <MenuItem value={"TW"}>Taiwan</MenuItem>
                                        <MenuItem value={"HK"}>Hong Kong</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                         <Grid size={8} sx={{pr: 1}}>
                            <TextField
                                fullWidth
                                required
                                id='localUserAccount' label={t('domain.common.customerAccountNumber')}
                                value={localUserAccount}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    setLocalUserAccount(event.target.value);
                                }}/>
                                 </Grid>
                        <Grid size={12} display='flex' justifyContent='right' sx={{pr: 1, pb: 1}}>
                            <Button
                                id='lookupByLocalUserAccount'
                                variant='contained'
                                onClick={handleAccountNumberLookupClicked}
                                disabled={!accountNumberLookupEnabled}>{t('common.lookup')}</Button>
                        </Grid>
                     </Grid>
                 </Paper>

                <Paper elevation={8} sx={{p: 0, bgcolor: lightBlue[50] }}>
                    <Grid container spacing={2}>
                        <Grid size={12} sx={{bgcolor: lightBlue[100], p: 1}}>
                            <Typography variant='h6'>{t('views.home.lookupByPhonePanel.title')}</Typography>
                        </Grid>
                        <Grid size={4} sx={{pl: 1}}>
                            <FormControl fullWidth>
                                <InputLabel id="phone-region-select-label" disabled={true}>{t('domain.common.region')}</InputLabel>
                                <Select
                                    id="phone-region-select"
                                    labelId="phone-region-select-label"
                                    label="Region"
                                    value={phoneRegion}
                                    onChange={handlePhoneRegionChange}>
                                    <MenuItem value={'JP'}>Japan (+81)</MenuItem>
                                    <MenuItem value={'KR'}>Korea (+82)</MenuItem>
                                    <MenuItem value={'TW'}>Taiwan (+886)</MenuItem>
                                    <MenuItem value={'HK'}>Hong Kong (+852)</MenuItem>
                                    <MenuItem value={'MO'} divider={true}>Macao (+853)</MenuItem>

                                    <MenuItem value={'CN'}>China (+86)</MenuItem>
                                    <MenuItem value={'DK'}>Denmark (+45)</MenuItem>
                                    <MenuItem value={'GB'}>United Kingdom (+44)</MenuItem>
                                    <MenuItem value={'US'}>United States (+1)</MenuItem>
                                    <MenuItem value={'BM'}>Bermuda (+1441)</MenuItem>
                                    <MenuItem value={'IN'}>India (+91)</MenuItem>

                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid size={8} sx={{pr: 1}}>
                            <TextField
                                id='customerPhoneNumber'
                                value={phoneNumber}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    setPhoneNumber(event.target.value);
                                }}
                                label={t('domain.common.customerPhoneNumber')}></TextField>
                        </Grid>
                        <Grid size={12} display='flex' justifyContent='right' sx={{pr: 1, pb: 1}}>
                            <Button id='lookupByPhoneNumber'
                                    onClick={handlePhoneNumberLookupClicked}
                                    variant='contained'
                                    disabled={!phoneNumberLookupEnabled}>{t('common.lookup')}</Button>
                        </Grid>
                    </Grid>
                </Paper>
        </Stack>
    );
}